/* eslint-disable react-hooks/exhaustive-deps */
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import {
    addDoc,
    collection,
    deleteDoc,
    doc,
    getDoc,
    getDocs,
    onSnapshot,
    orderBy,
    query,
    serverTimestamp,
    updateDoc,
    writeBatch,
    where,
} from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { Competence , CompetenceGroup } from "./competence.type";
// import { create } from "domain";
// import { update } from "firebase/database";
import { useLocationState } from "../../Utils";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Matiere } from "../matiere/matiere.type";


export const CompetenceApi = createApi({
    reducerPath: "competenceApi",
    tagTypes: ["competence", "competences", "competencesByStudent", 'competencesByCoran', 'competencesByProf'],
    baseQuery: fakeBaseQuery(),
    endpoints: (builder) => ({
        addOrEditCompetence: builder.mutation({
            async queryFn({ id, ...data }) {
                try {
                    const user = auth.currentUser;
                    if (!user) {
                        return { error: { message: "Aucun utilisateur connecté." } };
                    }
                    const userId = user.uid;

                    if (!id) {
                        const students: string[] = data.students ?? [];
                        const { students: _, ...dataWithoutStudents } = data;

                        // Cas 1 : pas d'étudiant → création simple
                        if (students.length === 0) {
                            const docRef = await addDoc(collection(db, "competences"), {
                                ...data,
                                createdAt: serverTimestamp(),
                                createdBy: userId,
                                updatedAt: serverTimestamp(),
                            });

                            return {
                                data: {
                                    id: docRef.id,
                                    message: "Compétence créée !",
                                    ...data,
                                },
                            };
                        }

                        // Cas 2 : avec étudiants → créer la compétence puis les competencesStudents
                        const docRef = await addDoc(collection(db, "competences"), {
                            ...data,
                            createdAt: serverTimestamp(),
                            createdBy: userId,
                            updatedAt: serverTimestamp(),
                        });

                        const docRefs = await Promise.all(
                            students.map((studentId: string) =>
                                addDoc(collection(db, "competencesStudents"), {
                                    studentId,
                                    competenceId: docRef.id,
                                    matiereId: dataWithoutStudents.matiere || "",
                                    status: dataWithoutStudents.status || "Non acquis",
                                    type: dataWithoutStudents.typeSpecific ?? null,
                                    createdAt: serverTimestamp(),
                                    createdBy: userId,
                                    updatedAt: serverTimestamp(),
                                })
                            )
                        );

                        return {
                            data: {
                                ids: docRefs.map((ref) => ref.id),
                                message: "Compétence créée !",
                                ...dataWithoutStudents,
                            },
                        };

                    } else {
                        // Mise à jour
                        // const compRef = doc(db, "competences", id);
                        // await updateDoc(compRef, { ...data, updatedAt: serverTimestamp() });

                        // --- MODIFICATION ---
                        const students: string[] = data.students ?? [];
                        const { students: _, ...dataWithoutStudents } = data;

                        // 1. Mettre à jour competence
                        const docRef = doc(db, "competences", id);
                        await updateDoc(docRef, {
                            ...data,
                            updatedAt: serverTimestamp(),
                        });

                        // 2. Récupérer les competencesStudents existants pour cet competence
                        const csQuery = query(
                            collection(db, "competencesStudents"),
                            where("competenceId", "==", id)
                        );
                        const csSnapshot = await getDocs(csQuery);

                        // IDs des étudiants déjà liés à cet competence
                        const existingStudentIds = csSnapshot.docs.map(
                            (d) => d.data().studentId as string
                        );

                        // 3. Ajouter les nouveaux étudiants qui n'existent pas encore
                        const studentsToAdd = students.filter(
                            (studentId) => !existingStudentIds.includes(studentId)
                        );

                        // 4. Supprimer les étudiants qui ont été retirés
                        const studentsToRemove = csSnapshot.docs.filter((d) =>
                            !students.includes(d.data().studentId)
                        );

                        await Promise.all([
                            // Ajout des nouveaux
                            ...studentsToAdd.map((studentId) =>
                                addDoc(collection(db, "competencesStudents"), {
                                    studentId,
                                    competenceId: docRef.id,
                                    matiereId: dataWithoutStudents.matiere || "",
                                    status: dataWithoutStudents.status || "Non acquis",
                                    type: dataWithoutStudents.typeSpecific ?? null,
                                    createdAt: serverTimestamp(),
                                    createdBy: userId,
                                    updatedAt: serverTimestamp(),
                                })
                            ),
                            // Suppression des retirés
                            ...studentsToRemove.map((d) =>
                                deleteDoc(doc(db, "competencesStudents", d.id))
                            ),
                        ]);


                        return {
                            data: {
                                message: "Compétence modifiée !",
                            },
                        };
                    }
                } catch (error: any) {
                    console.log("ERROR API", error);
                    return { error: { status: "CUSTOM", message: error.message } };
                }
            },
            invalidatesTags: ["competence", "competences", "competencesByStudent", "competencesByCoran"],
        }),
        assignCompetence: builder.mutation({
            async queryFn({ id, ...data }) {
                try {
                    const user = auth.currentUser;
                    if (!user) {
                        return { error: { message: "Aucun utilisateur connecté." } };
                    }
                    const userId = user.uid;
                    
                    const students: string[] = data.students ?? [];
                    const { students: _, ...dataWithoutStudents } = data;

                    console.log('dataWithoutStudents',dataWithoutStudents)

                    if(id) {
                        // 1. Récupérer le document actuel
                        const docRef = doc(db, "competences", id);
                        const docSnap = await getDoc(docRef);

                        // 2. Récupérer les anciens students
                        const existingStudents: string[] = docSnap.data()?.students ?? [];

                        // 3. Fusionner avec les nouveaux (sans doublons)
                        const newStudents: string[] = data.students ?? [];
                        const mergedStudents = Array.from(new Set([...existingStudents, ...newStudents]));

                        // 4. Mettre à jour
                        await updateDoc(docRef, {
                            ...dataWithoutStudents,
                            students: mergedStudents,
                            updatedAt: serverTimestamp(),
                        });
                    }

                    const docRefs = await Promise.all(
                        students.map((studentId: string) =>
                            addDoc(collection(db, "competencesStudents"), {
                                studentId,
                                competenceId: id || dataWithoutStudents.order ,
                                matiereId: dataWithoutStudents.matiere || "",
                                status: dataWithoutStudents.status || "Non acquis",
                                type: dataWithoutStudents.typeSpecific ?? null,
                                createdAt: serverTimestamp(),
                                createdBy: userId,
                                updatedAt: serverTimestamp(),
                            })
                        )
                    );

                    return {
                        data: {
                            message: "Compétence attribuée !",
                        },
                    };

                    
                } catch (error: any) {
                    console.log("ERROR API", error);
                    return { error: { status: "CUSTOM", message: error.message } };
                }
            },
            invalidatesTags: ["competence", "competences", "competencesByStudent", "competencesByCoran"],
        }),
        assignCompetences: builder.mutation({
            async queryFn({
                competences,
                studentIds,
                typeSpecific,
            }: {
                competences: Competence[];
                studentIds: string[];
                typeSpecific?: Competence["typeSpecific"];
            }) {
                try {
                    const user = auth.currentUser;
                    if (!user) return { error: { message: "Aucun utilisateur connecté." } };

                    const uniqueCompetences = Array.from(
                        new Map(competences.map((competence) => [competence.id, competence])).values()
                    );
                    const uniqueStudentIds = Array.from(new Set(studentIds));

                    if (!uniqueCompetences.length || !uniqueStudentIds.length) {
                        return { error: { message: "Veuillez sélectionner au moins une compétence et un élève." } };
                    }

                    const existingAssignments = await Promise.all(
                        uniqueStudentIds.map(async (studentId) => ({
                            studentId,
                            snapshot: await getDocs(
                                query(collection(db, "competencesStudents"), where("studentId", "==", studentId))
                            ),
                        }))
                    );
                    const existingQuranAssignments = new Set<string>();
                    existingAssignments.forEach(({ studentId, snapshot }) => {
                        snapshot.docs.forEach((assignment) => {
                            const data = assignment.data();
                            existingQuranAssignments.add(`${studentId}-${data.matiereId || ""}-${data.competenceId}`);
                        });
                    });

                    let batch = writeBatch(db);
                    let operationCount = 0;
                    let assignmentCount = 0;
                    const commitBatchIfNeeded = async (force = false) => {
                        if (operationCount === 0 || (!force && operationCount < 450)) return;
                        await batch.commit();
                        batch = writeBatch(db);
                        operationCount = 0;
                    };

                    for (const competence of uniqueCompetences) {
                        if (competence.type === "coran") {
                            for (const studentId of uniqueStudentIds) {
                                const assignmentKey = `${studentId}-${competence.matiere || ""}-${competence.order}`;
                                if (existingQuranAssignments.has(assignmentKey)) continue;

                                batch.set(doc(collection(db, "competencesStudents")), {
                                    studentId,
                                    competenceId: competence.order,
                                    matiereId: competence.matiere || "",
                                    status: competence.status || "Non acquis",
                                    type: typeSpecific ?? competence.typeSpecific ?? null,
                                    createdAt: serverTimestamp(),
                                    createdBy: user.uid,
                                    updatedAt: serverTimestamp(),
                                });
                                existingQuranAssignments.add(assignmentKey);
                                operationCount += 1;
                                assignmentCount += 1;
                                await commitBatchIfNeeded();
                            }
                            continue;
                        }

                        const competenceRef = doc(db, "competences", competence.id);
                        const competenceSnapshot = await getDoc(competenceRef);
                        if (!competenceSnapshot.exists()) {
                            return { error: { message: "Une compétence sélectionnée est introuvable." } };
                        }

                        const existingStudentIds: string[] = competenceSnapshot.data()?.students ?? [];
                        const studentsToAssign = uniqueStudentIds.filter((studentId) => !existingStudentIds.includes(studentId));
                        if (!studentsToAssign.length) continue;

                        batch.update(competenceRef, {
                            students: Array.from(new Set([...existingStudentIds, ...studentsToAssign])),
                            updatedAt: serverTimestamp(),
                        });
                        operationCount += 1;
                        await commitBatchIfNeeded();

                        for (const studentId of studentsToAssign) {
                            batch.set(doc(collection(db, "competencesStudents")), {
                                studentId,
                                competenceId: competence.id,
                                matiereId: competence.matiere || "",
                                status: competence.status || "Non acquis",
                                type: typeSpecific ?? competence.typeSpecific ?? null,
                                createdAt: serverTimestamp(),
                                createdBy: user.uid,
                                updatedAt: serverTimestamp(),
                            });
                            operationCount += 1;
                            assignmentCount += 1;
                            await commitBatchIfNeeded();
                        }
                    }

                    await commitBatchIfNeeded(true);

                    return {
                        data: {
                            message: assignmentCount
                                ? `${assignmentCount} attribution${assignmentCount > 1 ? "s" : ""} enregistrée${assignmentCount > 1 ? "s" : ""} !`
                                : "Les compétences sélectionnées sont déjà attribuées aux élèves choisis.",
                        },
                    };
                } catch (error: any) {
                    return { error: { status: "CUSTOM", message: error.message } };
                }
            },
            invalidatesTags: ["competence", "competences", "competencesByStudent", "competencesByCoran"],
        }),
        getCompetences: builder.query({
            async queryFn() {
                try {
                    return new Promise((resolve) => {
                        const q = query(
                            collection(db, "competences"),
                            orderBy("createdAt", "desc"),
                        );
                        onSnapshot(q, (snapshot) => {
                            const Competences = snapshot.docs.map((doc) => ({
                                id: doc.id,
                                ...doc.data(),
                            }));
                            resolve({ data: Competences as Competence[] });
                        });
                        // unsubscribe();
                    });
                } catch (error) {
                    return { error };
                }
            },
            keepUnusedDataFor: 0,
            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                const competencesRef = query(
                    collection(db, "competences"),
                    orderBy("createdAt", "desc"),
                );
                let unsubscribe;
                try {
                    await cacheDataLoaded;

                    unsubscribe = onSnapshot(competencesRef, (snapshot) => {
                        const competences = snapshot.docs.map((doc) => ({
                            id: doc.id,
                            ...doc.data(),
                        }));
                        updateCachedData(() => competences as Competence[]);
                    });
                } catch (error) {
                    console.error("Erreur de souscription:", error);
                }

                // Nettoyer l'écouteur Firestore quand le cache est supprimé
                await cacheEntryRemoved;
                if (unsubscribe) unsubscribe();
            },
            providesTags: ["competences"],
        }),
        getCompetencesByProf: builder.query({
            async queryFn() {
                const user = auth.currentUser;
                try {
                    return new Promise((resolve) => {
                        const q = query(
                            collection(db, "competences"),
                            where("createdBy", "==", user?.uid || ""),
                            orderBy("createdAt", "desc"),
                        );
                        onSnapshot(q, (snapshot) => {
                            const Competences = snapshot.docs.map((doc) => ({
                                id: doc.id,
                                ...doc.data(),
                            }));
                            resolve({ data: Competences as Competence[] });
                        });
                        // unsubscribe();
                    });
                } catch (error) {
                    return { error };
                }
            },
            keepUnusedDataFor: 0,
            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                const competencesRef = query(
                    collection(db, "competences"),
                    where("createdBy", "==", auth.currentUser?.uid || ""),
                    orderBy("createdAt", "desc"),
                );
                let unsubscribe;
                try {
                    await cacheDataLoaded;

                    unsubscribe = onSnapshot(competencesRef, (snapshot) => {
                        const competences = snapshot.docs.map((doc) => ({
                            id: doc.id,
                            ...doc.data(),
                        }));
                        updateCachedData(() => competences as Competence[]);
                    });
                } catch (error) {
                    console.error("Erreur de souscription:", error);
                }

                // Nettoyer l'écouteur Firestore quand le cache est supprimé
                await cacheEntryRemoved;
                if (unsubscribe) unsubscribe();
            },
            providesTags: ["competencesByProf"],
        }),
        getCompetencesByCoran: builder.query({
            async queryFn(title: string) {
                const user = auth.currentUser;
                try {
                    return new Promise((resolve) => {
                        const q = query(
                            collection(db, "competences"),
                            where("title", "==", title),
                            where("createdBy", "==", user?.uid || ""),
                            where("type", "==", "coran"),
                            orderBy("createdAt", "desc"),
                        );
                        onSnapshot(q, (snapshot) => {
                            const Competences = snapshot.docs.map((doc) => ({
                                id: doc.id,
                                ...doc.data(),
                            }));
                            resolve({ data: Competences as Competence[] });
                        });
                        // unsubscribe();
                    });
                } catch (error) {
                    return { error };
                }
            },
            keepUnusedDataFor: 0,
            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                const competencesRef = query(
                    collection(db, "competences"),
                    where("title", "==", arg),
                    where("createdBy", "==", auth.currentUser?.uid || ""),
                    where("type", "==", "coran"),
                    orderBy("createdAt", "desc"),
                );
                let unsubscribe;
                try {
                    await cacheDataLoaded;

                    unsubscribe = onSnapshot(competencesRef, (snapshot) => {
                        const competences = snapshot.docs.map((doc) => ({
                            id: doc.id,
                            ...doc.data(),
                        }));
                        updateCachedData(() => competences as Competence[]);
                    });
                } catch (error) {
                    console.error("Erreur de souscription:", error);
                }

                // Nettoyer l'écouteur Firestore quand le cache est supprimé
                await cacheEntryRemoved;
                if (unsubscribe) unsubscribe();
            },
            providesTags: ["competencesByCoran"],
        }),

        getCompetenceById: builder.query({
            queryFn: async (CompetenceId) => {
                try {
                    const CompetenceRef = doc(db, "competences", CompetenceId);
                    const CompetenceSnap = await getDoc(CompetenceRef);

                    if (!CompetenceSnap.exists()) {
                        return {
                            error: { status: 404, message: "Compétence introuvable !" },
                        };
                    }

                    return { data: { id: CompetenceSnap.id, ...CompetenceSnap.data() } };
                } catch (error: any) {
                    return { error: { status: 500, message: error.message } };
                }
            },
            providesTags: ["competence"],
        }),
        fetchCompetences: builder.query({
            
            async queryFn(matiereId: string) {
                
                if (!matiereId) return { error: { message: "matiereId manquant" } };

                try {
                const user = auth.currentUser;
                
                
                if (!user) return { error: { message: "Aucun utilisateur connecté." } };

                const q = query(
                    collection(db, "competences"),
                    where("createdBy", "==", user.uid),
                    where("matiere", "==", matiereId),
                    orderBy("createdAt", "desc")
                );


                const snapshot = await getDocs(q); 


                const competences = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                })) as any[];


                const competencesWithMatiere = await Promise.all(
                    competences.map(async (competence) => {
                    if (!competence.matiere) return competence;
                    try {
                        const matiereRef = doc(db, "matieres", competence.matiere);
                        const matiereSnap = await getDoc(matiereRef);
                        return {
                        ...competence,
                        matiereData: matiereSnap.exists()
                            ? { id: matiereSnap.id, ...matiereSnap.data() }
                            : competence.matiere,
                        };
                    } catch {
                        return competence;
                    }
                    })
                );

                // const grouped = groupByMatiere(competencesWithMatiere);

                return { data: competencesWithMatiere };
                } catch (error) {
                    console.error("ERREUR queryFn:", error);
                    return { error };
                }
            },

            keepUnusedDataFor: 60, 

            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                let unsubscribe: (() => void) | undefined;

                try {
                await cacheDataLoaded; 

                const user = auth.currentUser;
                if (!user) return;

                const q = query(
                    collection(db, "competences"),
                    where("createdBy", "==", user.uid),
                    where("matiere", "==", arg),
                    orderBy("createdAt", "desc")
                );

                unsubscribe = onSnapshot(q, async (snapshot) => {
                    const competences = snapshot.docs.map((d) => ({
                    id: d.id,
                    ...d.data(),
                    })) as any[];

                    const competencesWithMatiere = await Promise.all(
                    competences.map(async (competence) => {
                        if (!competence.matiere) return competence;
                        try {
                        const matiereRef = doc(db, "matieres", competence.matiere);
                        const matiereSnap = await getDoc(matiereRef);
                        return {
                            ...competence,
                            matiereData: matiereSnap.exists()
                            ? { id: matiereSnap.id, ...matiereSnap.data() }
                            : competence.matiere,
                        };
                        } catch {
                        return competence;
                        }
                    })
                    );
                    // const grouped = groupByMatiere(competencesWithMatiere);

                    updateCachedData(() => competencesWithMatiere);
                });

                } catch {
                // cacheDataLoaded rejeté → silencieux
                }

                await cacheEntryRemoved;
                if (unsubscribe) unsubscribe(); // nettoyage du listener
            },

            providesTags: ["competencesByStudent",'competencesByProf'],
        }),
        // Supprimer
        deleteCompetence: builder.mutation({
            queryFn: async (uid) => {
                try {
                    // Supprimer la compétence
                    const docRef = doc(db, "competences", uid);
                    await deleteDoc(docRef);

                    // Supprimer tous les competencesStudents liés
                    const competencesStudentsRef = collection(db, "competencesStudents");
                    const q = query(competencesStudentsRef, where("competenceId", "==", uid));
                    const snapshot = await getDocs(q);
                    await Promise.all(snapshot.docs.map((doc) => deleteDoc(doc.ref)));

                    return {
                        data: { id: uid, message: "Compétence supprimée !", success: true },
                    };
                } catch (error: any) {
                    return { error: { status: "DELETE_ERROR", message: error.message } };
                }
            },
            invalidatesTags: ["competence", "competences", "competencesByStudent", 'competencesByCoran', 'competencesByProf'],
        }),
    }),
});

export const {
    useAddOrEditCompetenceMutation,
    useGetCompetencesQuery,
    useDeleteCompetenceMutation,
    useLazyGetCompetenceByIdQuery,
    useLazyFetchCompetencesQuery,
    useGetCompetencesByCoranQuery,
    useGetCompetencesByProfQuery,
    useAssignCompetenceMutation,
    useAssignCompetencesMutation,
} = CompetenceApi;

export function useCompetenceFromLocation(): [
    Competence,
    boolean,
    string,
    (id: string) => any
] {
    const itemState = useLocationState<Competence | undefined>(undefined);
    const [item, setItem] = useState(itemState);
    const { id } = useParams<{ id: string }>();
    const [findById, { data, isError, isLoading }] = useLazyGetCompetenceByIdQuery();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            findById(id as string);
        }
    }, [id]);
    useEffect(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    useEffect(() => {
        if (data) {
            setItem(data as Competence);
        }
    }, [data]);

    return [item as Competence & { bio: string }, isLoading, id as string, findById];
}


const groupByMatiere = (competences: Competence[]): CompetenceGroup[] => {
    const map = new Map<string, CompetenceGroup>();

    for (const competence of competences) {
        const matiereData =
            competence.matiereData && typeof competence.matiereData === "object"
                ? (competence.matiereData as Matiere)
                : null;

        const key = matiereData?.id ?? competence.matiere ?? "sans-matiere";
        const title = matiereData?.title ?? competence.matiere ?? "Sans matière";

        if (!map.has(key)) {
            map.set(key, {
                id: key,
                matiereTitle: title,
                matiereData: matiereData,
                competences: [],
            });
        }

        map.get(key)!.competences.push(competence);
    }

    // Tri alphabétique sur le titre de la matière
    return Array.from(map.values()).sort((a, b) =>
        a.matiereTitle.localeCompare(b.matiereTitle, "fr")
    );
}

const getCompetences = async (userId: string, matiereId?: string) => {
  const competencesRef = collection(db, "competences");

  const constraints: any[] = [
    where("createdBy", "==", userId),
    orderBy("createdAt", "asc"),
  ];

  if (matiereId) {
    constraints.splice(1, 0, where("matiere", "==", matiereId));
  }

  const q = query(competencesRef, ...constraints);
  const snapshot = await getDocs(q);

  const competencesRaw = snapshot.docs.map(docComp => ({
    id: docComp.id,
    ...docComp.data()
  })) as Competence[];

  return enrichMatiere(competencesRaw);
};

const enrichMatiere = async (competences: Competence[]) => {
  return Promise.all(
    competences.map(async (competence) => {
      if (!competence.matiere) return competence;

      try {
        const matiereSnap = await getDoc(doc(db, "matieres", competence.matiere));

        return {
          ...competence,
          matiereData: matiereSnap.exists()
            ? { uid: matiereSnap.id, ...matiereSnap.data() }
            : null,
        };
      } catch {
        return competence;
      }
    })
  );
};
